import React from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

import PageWithLayout from 'src/components/layout/PageWithLayout';
import { JobsTable } from 'src/features/job/components/JobsTable';
import { RootState } from 'src/store';

const JobPage: React.FC = () => {
	const { siteSlug } = useParams<{
		siteSlug: string;
	}>();

	const siteDetails = useSelector(
		(state: RootState) => state.site.siteDetails,
	);

	const breadcrumbs = [
		{
			label: siteDetails?.name || 'Site Details',
			href: `/site/${siteSlug}`,
		},
		{ label: 'Downloads' },
	];

	return (
		<PageWithLayout breadcrumbs={breadcrumbs}>
			<JobsTable />
		</PageWithLayout>
	);
};

export default JobPage;
